export const REPORTING_PAGE_NS = 'pages/PerformanceReportPage';

export const i18n = {
  en: {
    buttons: {
      builder: 'Builder',
    },
    filtersModal: {
      title: 'Set Up {{displayName}}',
      description: 'Before proceeding, select filters to load relevant data on the dashboard.',
      button: {
        done: 'Done',
      },
    },
  },
};
